import { render, staticRenderFns } from "./ContractTab.vue?vue&type=template&id=f6360b5a&scoped=true"
import script from "./ContractTab.vue?vue&type=script&lang=js"
export * from "./ContractTab.vue?vue&type=script&lang=js"
import style0 from "./ContractTab.vue?vue&type=style&index=0&id=f6360b5a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6360b5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6360b5a')) {
      api.createRecord('f6360b5a', component.options)
    } else {
      api.reload('f6360b5a', component.options)
    }
    module.hot.accept("./ContractTab.vue?vue&type=template&id=f6360b5a&scoped=true", function () {
      api.rerender('f6360b5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/tabs/ContractTab.vue"
export default component.exports